export default {
      id: "pauseCircleFilled-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#pauseCircleFilled-usage",
      toString: function () {
        return this.url;
      }
    }